const GOLD = "#84DFF4";

// 14×14 instrument glyphs — one per room. Stroke/fill come from currentColor.
export const Glyph = ({ kind, active = false }) => {
  const halo = active ? <circle cx="7" cy="7" r="6.5" fill={GOLD} fillOpacity="0.12" /> : null;
  switch (kind) {
    case "point":
      return <svg viewBox="0 0 14 14" width="14" height="14" aria-hidden="true">{halo}<circle cx="7" cy="7" r="1.7" fill="currentColor" /></svg>;
    case "hairline":
      return <svg viewBox="0 0 14 14" width="14" height="14" aria-hidden="true">{halo}<line x1="7" y1="1.5" x2="7" y2="12.5" stroke="currentColor" strokeWidth="1" /></svg>;
    case "disc":
      return <svg viewBox="0 0 14 14" width="14" height="14" aria-hidden="true">{halo}<circle cx="7" cy="7" r="4.2" fill="currentColor" fillOpacity="0.28" /><circle cx="7" cy="7" r="1.2" fill="currentColor" /></svg>;
    case "cluster":
      return <svg viewBox="0 0 14 14" width="14" height="14" aria-hidden="true">{halo}<circle cx="7" cy="3.6" r="1.2" fill="currentColor" /><circle cx="3.8" cy="9.4" r="1.2" fill="currentColor" /><circle cx="10.2" cy="9.4" r="1.2" fill="currentColor" /></svg>;
    case "crosshair":
      return <svg viewBox="0 0 14 14" width="14" height="14" aria-hidden="true">{halo}<line x1="7" y1="1" x2="7" y2="4.5" stroke="currentColor" strokeWidth="0.9" /><line x1="7" y1="9.5" x2="7" y2="13" stroke="currentColor" strokeWidth="0.9" /><line x1="1" y1="7" x2="4.5" y2="7" stroke="currentColor" strokeWidth="0.9" /><line x1="9.5" y1="7" x2="13" y2="7" stroke="currentColor" strokeWidth="0.9" /><circle cx="7" cy="7" r="1.4" fill="none" stroke="currentColor" strokeWidth="0.8" /></svg>;
    default:
      return null;
  }
};
